/* eslint-disable */
import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const HomeIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 11.5L12 4l9 7.5" />
    <path d="M5 10.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1v-9.5" />
  </svg>
);

const BackIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

export default function PageTopBar({
  variant = "home",
  to,
  label = "홈으로 이동",
  dark = false,
  borderColor,
  right,
}) {
  const nav = useNavigate();

  const handleClick = () => {
    if (to) {
      nav(to);
    } else if (variant === "back") {
      nav(-1);
    } else {
      nav("/home");
    }
  };

  return (
    <Bar $dark={dark} $borderColor={borderColor}>
      <button onClick={handleClick} aria-label={label} type="button">
        {variant === "back" ? <BackIcon /> : <HomeIcon />}
        {label}
      </button>
      {right && <Right>{right}</Right>}
    </Bar>
  );
}

/* ── right-slot pill button ── */
const ActionButton = styled.button`
  appearance: none;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 12px !important;
  font-weight: 600;
  background: #fff;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #111;
`;

PageTopBar.ActionButton = ActionButton;

/* ── styled pieces ── */
const Right = styled.div`
  margin-left: auto;
  display: flex;
  gap: 8px;
`;

const Bar = styled.div`
  height: 52px;
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0 12px;
  border-bottom: 1px solid
    ${({ $dark, $borderColor }) =>
      $borderColor || ($dark ? "rgba(255,255,255,0.08)" : "#e6eefc")};

  > button {
    appearance: none;
    background: transparent;
    border: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: ${({ $dark }) => ($dark ? "#fff" : "#111")};
    font-weight: 700;
    padding: 6px 8px;
    border-radius: 10px;

    &:active {
      transform: translateY(1px);
    }

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;
